var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    ("" + _vm.classPrefix),
    _vm.menuComponent.theme && (_vm.classPrefix + "--" + (_vm.menuComponent.theme)),
    _vm.menuComponent.mode && (_vm.classPrefix + "--" + (_vm.menuComponent.mode)) ]},[_c('div',{class:[(_vm.classPrefix + "__title")],style:(_vm.groupStyle)},[_vm._t("title",[_vm._v(_vm._s(_vm.name))])],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }